import { render, staticRenderFns } from "./ApiLimits.vue?vue&type=template&id=74356746&scoped=true&"
import script from "./ApiLimits.vue?vue&type=script&lang=js&"
export * from "./ApiLimits.vue?vue&type=script&lang=js&"
import style0 from "./ApiLimits.vue?vue&type=style&index=0&id=74356746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74356746",
  null
  
)

export default component.exports